// extracted by mini-css-extract-plugin
module.exports = {"CmsNodes":"CmsNodes_CmsNodes__TqUpK","Nyheter":"CmsNodes_Nyheter__3nZGv"};